// extracted by mini-css-extract-plugin
export default {"projbutton":"Project-A_projbutton__tGfvV"};